/* eslint-disable */
import React, { Component } from 'react'; 
import Image from '../UiComponent/Image';
import './NotFound.scss';
import HTMLText from '../UiComponent/HTMLText';
import  './FormPage.scss'
class NotFound extends Component {


	constructor(props) {
		super(props);	
		this.state = {
		
		};
		
		}
	
	componentDidMount() {	
		
	}

	componentWillUnmount() {
	}



	render() {			
		return (
            <div id="NotFoundPage">	
			<div className='form-title'>
					<div className='form-title-image-overlay'></div>
					<HTMLText className='title-desc' text='404!'/>
				</div>
					
            </div>
		);
	}
}

export default NotFound;